import { translate } from '../../i18n';
import { ITranslations } from '../../i18n/config';

interface HeaderLink {
  label: ITranslations;
  href: string;
  condition?: (user: Api.User) => boolean;
}

const links: HeaderLink[] = [
  { label: 'dashboard.title', href: '/' },
  { label: 'data.overview.title', href: '/gegevens' },
  {
    label: 'acard.title',
    href: '/a-kaart',
    condition: (user: Api.User) => {
      return user.acard !== undefined;
    },
  },
  { label: 'ecounter.title', href: '/mijn-eloket' },
];

export const useHeaderLinks = (user: Api.User) => {
  return links
    .filter((link) => {
      if (!link.condition) return true;

      return link.condition(user);
    })
    .map((link) => ({
      ...link,
      label: translate(link.label),
    }));
};
